import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import { getStep, updateStep } from "containers/CreateWizard/reducer";

import ContinuousTime from "components/CreateWizard/Costs/ContinuousTime";

class ContinuousTimeContainer extends React.PureComponent {
  render() {
    const { step, index, isShow } = this.props;

    return <ContinuousTime {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateStep: (step) => dispatch(updateStep(step)),
  updateTimePeriod: (timePeriod) => dispatch(setupReducer.updateTimePeriod(ownProps.id, timePeriod)),
  updateUnitType: (unitType) => dispatch(setupReducer.updateUnitType(ownProps.id, unitType))
});

const mapStateToProps = (state, ownProps) => ({
  isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",

  outcome: setupReducer.getOutcomeFromDataset(state, ownProps.id),
  success: setupReducer.getSuccessValue(state, ownProps.id),

  timePeriod: setupReducer.getTimePeriod(state, ownProps.id),

  step: getStep(state),
  unitType: setupReducer.getUnitType(state, ownProps.id)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ContinuousTimeContainer);
